export const STORE_DESIGNS = {
  9: {
    id: 9,
    name: 'Bazar Lumina',
    slug: 'bazar-lumina',
    market: 'bazar',
    home: 'man',
    nav: 'bazar-lumina',
    productCard: 'editorial',
  },
  10: {
    id: 10,
    name: 'Tecno Pulse',
    slug: 'tecno-pulse',
    market: 'electronics',
    home: 'man',
    nav: 'tecno-pulse',
    productCard: 'compact',
  },
  11: {
    id: 11,
    name: 'Hombre Atelier',
    slug: 'hombre-atelier',
    market: 'menswear',
    home: 'man',
    nav: 'hombre-atelier',
    productCard: 'editorial',
  },
  12: {
    id: 12,
    name: 'Mujer Maison',
    slug: 'mujer-maison',
    market: 'womenswear',
    home: 'd5',
    nav: 'mujer-maison',
    productCard: 'editorial',
  },
  13: {
    id: 13,
    name: 'Deco Serena',
    slug: 'deco-serena',
    market: 'home-deco',
    home: 'd5',
    nav: 'deco-serena',
    productCard: 'soft',
  },
  14: {
    id: 14,
    name: 'Kids Pop',
    slug: 'kids-pop',
    market: 'kids',
    home: 'd5',
    nav: 'kids-pop',
    productCard: 'soft',
  },
  15: {
    id: 15,
    name: 'Beauty Glow',
    slug: 'beauty-glow',
    market: 'beauty',
    home: 'd5',
    nav: 'beauty-glow',
    productCard: 'soft',
  },
  16: {
    id: 16,
    name: 'Sport Grid',
    slug: 'sport-grid',
    market: 'sports',
    home: 'man',
    nav: 'sport-grid',
    productCard: 'compact',
  },
  17: {
    id: 17,
    name: 'Pet Friendly',
    slug: 'pet-friendly',
    market: 'pet',
    home: 'd5',
    nav: 'pet-friendly',
    productCard: 'soft',
  },
  18: {
    id: 18,
    name: 'Gourmet Fresh',
    slug: 'gourmet-fresh',
    market: 'gourmet',
    home: 'man',
    nav: 'gourmet-fresh',
    productCard: 'compact',
  },
  19: {
    id: 19,
    name: 'Urban Drop',
    slug: 'urban-drop',
    market: 'streetwear',
    home: 'man',
    nav: 'urban-drop',
    productCard: 'editorial',
  },
  20: {
    id: 20,
    name: 'Prisma Joyas',
    slug: 'prisma-joyas',
    market: 'jewelry',
    home: 'd5',
    nav: 'prisma-joyas',
    productCard: 'soft',
  },
  21: {
    id: 21,
    name: 'Papel Vivo',
    slug: 'papel-vivo',
    market: 'bookstore',
    home: 'man',
    nav: 'papel-vivo',
    productCard: 'compact',
  },
  22: {
    id: 22,
    name: 'Nordika Home',
    slug: 'nordika-home',
    market: 'furniture',
    home: 'd5',
    nav: 'nordika-home',
    productCard: 'editorial',
  },
  23: {
    id: 23,
    name: 'Auto Pro',
    slug: 'auto-pro',
    market: 'autoparts',
    home: 'man',
    nav: 'auto-pro',
    productCard: 'compact',
  },
  24: {
    id: 24,
    name: 'Farma Clara',
    slug: 'farma-clara',
    market: 'pharmacy',
    home: 'd5',
    nav: 'farma-clara',
    productCard: 'compact',
  },
  25: {
    id: 25,
    name: 'Toolbox Pro',
    slug: 'toolbox-pro',
    market: 'hardware',
    home: 'man',
    nav: 'toolbox-pro',
    productCard: 'compact',
  },
  26: {
    id: 26,
    name: 'Raíz Artesanal',
    slug: 'raiz-artesanal',
    market: 'handmade',
    home: 'd5',
    nav: 'raiz-artesanal',
    productCard: 'soft',
  },
  27: {
    id: 27,
    name: 'Neon Gamer',
    slug: 'neon-gamer',
    market: 'gaming',
    home: 'man',
    nav: 'neon-gamer',
    productCard: 'compact',
  },
  28: {
    id: 28,
    name: 'Terra Outdoor',
    slug: 'terra-outdoor',
    market: 'outdoor',
    home: 'man',
    nav: 'terra-outdoor',
    productCard: 'editorial',
  },
};

export const getStoreDesign = (design) => STORE_DESIGNS[Number(design)] || null;

export const isStoreDesign = (design) => Boolean(getStoreDesign(design));

const DEFAULT_STORE_HOME_PRESENTATION = {
  hero: 'poster',
  products: 'grid',
  productLimit: 8,
  brands: 'grid',
};

export const STORE_HOME_PRESENTATIONS = {
  'bazar-lumina': { hero: 'mosaic', products: 'mosaic', productLimit: 9, brands: 'grid' },
  'tecno-pulse': { hero: 'command', products: 'grid', productLimit: 8, brands: 'grid' },
  'hombre-atelier': { hero: 'split', products: 'editorial', productLimit: 6, brands: 'text' },
  'mujer-maison': { hero: 'poster', products: 'mosaic', productLimit: 8, brands: 'grid' },
  'deco-serena': { hero: 'split', products: 'grid', productLimit: 8, brands: 'grid' },
  'kids-pop': { hero: 'poster', products: 'tiles', productLimit: 8, brands: 'grid' },
  'beauty-glow': { hero: 'mosaic', products: 'editorial', productLimit: 6, brands: 'grid' },
  'sport-grid': { hero: 'command', products: 'grid', productLimit: 8, brands: 'text' },
  'pet-friendly': { hero: 'poster', products: 'tiles', productLimit: 8, brands: 'grid' },
  'gourmet-fresh': { hero: 'split', products: 'mosaic', productLimit: 9, brands: 'text' },
  'urban-drop': { hero: 'command', products: 'mosaic', productLimit: 9, brands: 'text' },
  'prisma-joyas': { hero: 'poster', products: 'editorial', productLimit: 6, brands: 'grid' },
  'papel-vivo': { hero: 'split', products: 'list', productLimit: 6, brands: 'text' },
  'nordika-home': { hero: 'mosaic', products: 'grid', productLimit: 8, brands: 'grid' },
  'auto-pro': { hero: 'command', products: 'grid', productLimit: 8, brands: 'text' },
  'farma-clara': { hero: 'poster', products: 'list', productLimit: 6, brands: 'grid' },
  'toolbox-pro': { hero: 'command', products: 'tiles', productLimit: 8, brands: 'text' },
  'raiz-artesanal': { hero: 'split', products: 'editorial', productLimit: 6, brands: 'grid' },
  'neon-gamer': { hero: 'command', products: 'mosaic', productLimit: 9, brands: 'text' },
  'terra-outdoor': { hero: 'mosaic', products: 'grid', productLimit: 8, brands: 'text' },
};

export const getStoreHomePresentation = (slug) => ({
  ...DEFAULT_STORE_HOME_PRESENTATION,
  ...(STORE_HOME_PRESENTATIONS[slug] || {}),
});
